export default __webpack_public_path__ + "static/genopets-3-a-ee2ec55c28854aa5ce4efa1a65fa1a38.webp";